import { array } from 'fp-ts';
import { WithServiceId } from '@mews-commander/types';
import { keyBy } from '@mews/fp';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { FilterFormValues } from '../schemas';
import { SellLimitMatrixRowData } from '../types';

interface Params extends WithServiceId {
    filterValues: FilterFormValues;
}

export const useSellLimitsMatrixData = ({ filterValues, serviceId }: Params) =>
    useRepositoryQuery(
        'sellLimits',
        'get',
        {
            firstTimeUnitStartUtc: filterValues.startDate,
            lastTimeUnitStartUtc: filterValues.endDate,
            serviceId,
            rateGroupId: filterValues.view.type === 'rateGroup' ? filterValues.view.value : null,
            rateId: filterValues.view.type === 'rate' ? filterValues.view.value : null,
            resourceCategoryIds: filterValues.resourceCategories,
        },
        {
            select: ({ data }): SellLimitMatrixRowData[] => {
                if (data) {
                    // @ts-expect-error will be fixed once types are generated
                    return data.map(({ data: timeUnitDataArray, ...other }) => ({
                        ...other,
                        id: other.resourceCategoryId,
                        data:
                            timeUnitDataArray && array.isNonEmpty(timeUnitDataArray)
                                ? keyBy('timeUnitBaseStartUtc', timeUnitDataArray)
                                : {},
                    }));
                }
                return [];
            },
        }
    );
